const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const AppActionConstants = require('../constants/AppActionConstants');

const ActionTypes = AppActionConstants.ActionTypes.messages;

module.exports = {
    clearStoredMessage: function () {
        AppDispatcher.dispatch({
            type: ActionTypes.CLEAR_STORED_MESSAGE
        });
    }
};
